import React from "react";

function HowItWorks() {
  return (
    <div>
      <section className="about-main-sec visual-graphics-box w-100 float-left padding-top bg-light-black">
        <div className="wrapper2 ">
          <div className="row padding-top">
            <div className="col-lg-7 ">
              <div className="visual-left-sec position-relative">
                <figure
                  className="mb-0"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <img
                    src="../assets/images/img/how-to-get-starte.jpg"
                    alt="eagle-img"
                  />
                </figure>
                <div
                  className="visual-small-img"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <figure className="mb-0">
                    <img
                      src="../assets/images/img/create_your_wallet_img.jpg"
                      alt="visual-small-img"
                    />
                  </figure>
                </div>
              </div>
            </div>
            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div className="about-details-box">
                <div className="generic-title">
                  <h2
                    className="mb-0 h1 text-white"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    How to Get Started with DNET?
                  </h2>
                </div>
                <p data-aos="fade-up" data-aos-duration={600}>
                  Our Tools Simplify And Accelerate Workflows,
                  <br /> Foster Creativity, And Enable Others To Create <br />{" "}
                  New Products.
                </p>
                <ul className="list-unstyled">
                  <li
                    className="position-relative"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <figure className="mb-0">
                      <img
                        src="../assets/images/img/about-tick-img.png"
                        alt="about-tick-img"
                      />
                    </figure>{" "}
                    Sign Up & Create Your Wallet.
                  </li>
                  <li
                    className="position-relative"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <figure className="mb-0">
                      <img
                        src="../assets/images/img/about-tick-img.png"
                        alt="about-tick-img"
                      />
                    </figure>{" "}
                    Deposit Funds Securely.
                  </li>
                  <li
                    className="position-relative"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <figure className="mb-0">
                      <img
                        src="../assets/images/img/about-tick-img.png"
                        alt="about-tick-img"
                      />
                    </figure>{" "}
                    Access Financial Tools & Features.
                  </li>
                  <li
                    className="position-relative"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <figure className="mb-0">
                      <img
                        src="../assets/images/img/about-tick-img.png"
                        alt="about-tick-img"
                      />
                    </figure>{" "}
                    Withdraw & Manage Your Assets Seamlessly.
                  </li>
                </ul>
                <div className="d-flex ">
                  <a
                    className="button-1 px-5 my-2 my-lg-0"
                    href="#"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <div className="dots_border" />

                    <span className="text_button mb-0">Sign Up Now</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HowItWorks;
